import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import ToolsPage from 'src/modules/tools/components/pages/tools.page';
import { globalSearchSchema } from 'src/modules/shared/schemas/search.schema';

const toolsSearchSchema = globalSearchSchema.merge(
  z.object({
    phoneVersion: globalSearchSchema.shape.phoneVersion.default('v1' as const),
  })
);

export const Route = createFileRoute('/tools/')({
  component: ToolsLayoutComponent,
  validateSearch: (search) => toolsSearchSchema.parse(search),
});

function ToolsLayoutComponent() {
  return (
    <AuthenticateRoute>
      <ToolsPage />
    </AuthenticateRoute>
  );
}
